export default class Banner {
    static init() {
        const banners = document.querySelectorAll('.sticky-picture');

        if (banners.length > 0 && window.matchMedia('(min-width:1280px)').matches) {
            banners.forEach( banner => {
                setTimeout(function () {
                    Banner.scrollSticky(banner);
                }, 500);
            });
        }
    }
    static scrollSticky(banner) {
        let offsetTop = banner.getBoundingClientRect().top;

        window.addEventListener("scroll", function() {
                let scrollPosY = window.pageYOffset;

                if (scrollPosY > (offsetTop + 20) ) {
                    banner.classList.add('fixed');
                } else {
                    banner.classList.remove('fixed');
                }
        });
    }
}